/**
 * @generated SignedSource<<1137cbfff7d16fdcf17c1b9e7c986abe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type AddAccountGroupInput = {
  description?: string | null | undefined;
  dynamicFilter?: string | null | undefined;
  items?: ReadonlyArray<AccountGroupElement> | null | undefined;
  name: string;
  owner?: any | null | undefined;
  priority?: number | null | undefined;
  provider: CloudProvider;
  regions?: ReadonlyArray<string> | null | undefined;
  shortName?: string | null | undefined;
  variables?: string | null | undefined;
};
export type AccountGroupElement = {
  key: string;
  provider: CloudProvider;
  regions?: ReadonlyArray<string> | null | undefined;
};
export type AddAccountGroupMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddAccountGroupInput;
};
export type AddAccountGroupMutation$data = {
  readonly addAccountGroup: {
    readonly group: {
      readonly dynamicFilter: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly provider: CloudProvider;
      readonly regions: ReadonlyArray<string> | null | undefined;
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type AddAccountGroupMutation = {
  response: AddAccountGroupMutation$data;
  variables: AddAccountGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountGroup",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dynamicFilter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "addAccountGroup",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AddAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "addAccountGroup",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "group",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AccountGroupEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bb85e2da6b5a5a18d6dca471ea05fd42",
    "id": null,
    "metadata": {},
    "name": "AddAccountGroupMutation",
    "operationKind": "mutation",
    "text": "mutation AddAccountGroupMutation(\n  $input: AddAccountGroupInput!\n) {\n  addAccountGroup(input: $input) {\n    group {\n      dynamicFilter\n      id\n      name\n      provider\n      regions\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcf5cff01a38b3bec569baa469d008d4";

export default node;
